import { deleteProjectAndChats } from "../apigateway/mongocalls";
import getuser from "../aws_utils/getAuthuser";

export default async function deleteUserProjectChat(projectname) {


    let userid = ""
    try {
        const currentuser = await getuser();
        userid = currentuser.username;
    } catch (error) {
        console.log(error);
    }

    try {
        await deleteProjectAndChats(userid, projectname);
    } catch (error) {
        console.log('delete project and chats error')
    }

    return



}